var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmilesDailyObjective = function SvgSmilesDailyObjective(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174.273,
    height: 114.145,
    viewBox: "0 0 174.273 114.145",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_228",
    "data-name": "Grupo 228",
    transform: "translate(-92.778 -115.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "raios",
    transform: "translate(115 117.395)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_38",
    "data-name": "Linha 38",
    y1: 22.451,
    transform: "translate(65.261 0)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_39",
    "data-name": "Linha 39",
    y1: 19.443,
    x2: 11.225,
    transform: "translate(86.501 8.839)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_40",
    "data-name": "Linha 40",
    y1: 11.225,
    x2: 19.441,
    transform: "translate(101.98 32.726)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_48",
    "data-name": "Linha 48",
    x1: 19.442,
    y1: 11.225,
    transform: "translate(8.839 32.274)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linha_49",
    "data-name": "Linha 49",
    x1: 11.225,
    y1: 19.441,
    transform: "translate(32.726 8.578)",
    opacity: 0.3,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ILUSTRA",
    transform: "translate(-0.695 -81.498)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1473",
    "data-name": "Ret\\xE2ngulo 1473",
    width: 36,
    height: 19,
    transform: "translate(162.695 273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1474",
    "data-name": "Ret\\xE2ngulo 1474",
    width: 36,
    height: 19,
    transform: "translate(100.695 273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_812",
    "data-name": "Caminho 812",
    d: "M44.98,1.784a25.52,25.52,0,1,1-14.372,33.1A25.522,25.522,0,0,1,44.98,1.784ZM65.461,30.718a1.7,1.7,0,0,1,3.054,1.474,15.754,15.754,0,0,1-28.337,0,1.7,1.7,0,0,1,3.054-1.474,12.356,12.356,0,0,0,22.229,0Z",
    transform: "translate(126.264 250.003)",
    fill: "#9fc540",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_813",
    "data-name": "Caminho 813",
    d: "M73.026,1.784a25.52,25.52,0,1,1-14.372,33.1,25.522,25.522,0,0,1,14.372-33.1Zm-3.275,33.2a1.693,1.693,0,0,1,0-3.385H95.034a1.693,1.693,0,0,1,0,3.386H69.751Z",
    transform: "translate(36.607 250.003)",
    fill: "#00a6e4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_211443840",
    d: "M20.467,24.734c8.165,0,14.786,1.655,14.786,3.7s-6.621,3.7-14.786,3.7S5.681,30.471,5.681,28.43,12.3,24.734,20.467,24.734Z",
    transform: "translate(98.754 279.413)",
    fill: "rgba(31,26,23,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_211443936",
    d: "M48.513,24.734c8.164,0,14.786,1.655,14.786,3.7s-6.621,3.7-14.786,3.7-14.786-1.655-14.786-3.7S40.348,24.734,48.513,24.734Z",
    transform: "translate(132.097 279.413)",
    fill: "rgba(31,26,23,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_211443720",
    d: "M76.559,24.734c8.164,0,14.786,1.655,14.786,3.7s-6.621,3.7-14.786,3.7-14.786-1.655-14.786-3.7S68.395,24.734,76.559,24.734Z",
    transform: "translate(165.44 279.413)",
    fill: "rgba(31,26,23,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1478",
    "data-name": "Ret\\xE2ngulo 1478",
    width: 36,
    height: 19,
    transform: "translate(224.695 273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_839",
    "data-name": "Caminho 839",
    d: "M16.934,1.784a25.52,25.52,0,1,1-14.372,33.1,25.523,25.523,0,0,1,14.372-33.1ZM26.3,25.523H10.76a15.54,15.54,0,1,0,31.08,0H26.3Z",
    transform: "translate(215.921 250.003)",
    fill: "#f5b827",
    fillRule: "evenodd"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmilesDailyObjective, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smiles_daily_objective.b25d553e.svg";
export { ForwardRef as ReactComponent };